// departmen cookie is set on
// -- 1. every page load
// -- 2. department change

const departmentCookieName = "_ocmDepartment";

export function setDepartmentCookie(department) {
	if (!department || typeof department !== "string") return;

	const date = new Date();
	date.setFullYear(date.getFullYear() + 1); // expires in 1 year
	document.cookie = `${departmentCookieName}=${department}; expires=${date.toUTCString()}; path=/`;
}

export function getDepartmentCookie() {
	const department = getCookie(departmentCookieName);
	if (department === null) return null;

	const normalizedDepartment = normalizeLegacyDepartment(department);
	if (!isValidDepartment(normalizedDepartment)) {
		unsetDepartmentCookie();
		return null;
	}

	if (normalizedDepartment !== department) {
		setDepartmentCookie(normalizedDepartment);
	}

	return normalizedDepartment;
}

// Helper functions

function getCookie(name) {
	const regex = new RegExp('(?:^|; )' + name + '=([^;]*)');
	const match = regex.exec(document.cookie);
	if (!match) return null;

	try {
		return decodeURIComponent(match[1]);
	} catch {
		return match[1];
	}
}

/*
Normalization can be removed in the future in about 1.5 years, when we are sure that all users have the new cookie value.
It is only needed to support users who have the old cookie which lasts for 1 year.
 */
function normalizeLegacyDepartment(department) {
	if (typeof department !== "string") return department;

	const normalizedInput = department.trim().toLowerCase();
	const legacyDepartmentMap = {
		male: "men",
		female: "women",
	};
	const canonicalDepartments = {
		men: true,
		women: true,
		kids: true,
	};

	if (canonicalDepartments[normalizedInput]) return normalizedInput;

	return legacyDepartmentMap[normalizedInput] || department;
}

function isValidDepartment(department) {
	return department === "men" || department === "women" || department === "kids";
}

function unsetDepartmentCookie() {
	document.cookie = `${departmentCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
